import { RouteItem } from '@eastcoal/router/types/route'

import { AREA_PAGE_PATH } from './constants/path'
import { AREA_PAGE_UUID, AREA_ACTION_UUID } from './constants/uuids'

export const areaRoute: RouteItem = {
  title: '地址管理',
  path: AREA_PAGE_PATH,
  uuid: AREA_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理地址',
      uuid: AREA_ACTION_UUID
    }
  ]
}
